import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  resetOnClickFilter,
  applyFilterInIncomingClientsTable,
} from "../../redux/actions";
import styled from "styled-components";

const BodyWrapper = styled.div`
  .section {
    .inputBoxName {
      font-weight: 700;
      font-size: 12px;
      color: #004576;
    }

    .inputBoxContainer {
      border-bottom: 1px solid rgba(0, 0, 0, 0.15);
      padding: 5px 2px;

      .inputBox {
        border: none;
        background: transparent;
        padding-left: 5px;
      }
    }
  }
`;

const GoalFilter = () => {
  const dispatch = useDispatch();
  const {
    filterSaveClickColumnName,
    filterClearClickColumnName,
    filterDataOnIncomingClientTable,
  } = useSelector((state) => state.user);

  const [lowGoalRange, setLowGoalRange] = useState("");
  const [highGoalRange, setHighGoalRange] = useState("");

  useEffect(() => {
    if (filterClearClickColumnName === "Goal") {
      setLowGoalRange("");
      setHighGoalRange("");
      dispatch(resetOnClickFilter());
    }
  }, [filterClearClickColumnName]);

  useEffect(() => {
    if (filterSaveClickColumnName === "Goal") {
      let tempFilter = [...filterDataOnIncomingClientTable];
      if (lowGoalRange == "") {
        tempFilter = tempFilter.filter((data) => data.columnName !== "Goal");
        dispatch(applyFilterInIncomingClientsTable(tempFilter));
      } else {
        let flag = 0;
        tempFilter.forEach((data) => {
          if (data.columnName === "Goal") {
            data.LowerLimit = lowGoalRange;
            data.UpperLimit = highGoalRange;
            data.LowerLimitByText = "$" + lowGoalRange;
            data.UpperLimitByText = "$" + highGoalRange;
            flag = 1;
          }
        });
        if (flag === 0) {
          tempFilter.push({
            columnName: "Goal",
            LowerLimit: lowGoalRange,
            UpperLimit: highGoalRange,
            LowerLimitByText: "$" + lowGoalRange,
            UpperLimitByText: "$" + highGoalRange,
          });
        }
        dispatch(applyFilterInIncomingClientsTable(tempFilter));
      }

      dispatch(resetOnClickFilter());
    }
  }, [filterSaveClickColumnName]);

  useEffect(() => {
    let dateFilterData = filterDataOnIncomingClientTable.filter(
      (data) => data.columnName === "Goal"
    );
    if (dateFilterData.length > 0) {
      setLowGoalRange(dateFilterData[0].LowerLimit);
      setHighGoalRange(dateFilterData[0].UpperLimit);
    }
  }, [filterDataOnIncomingClientTable]);

  const handleTextBoxChange = (event) => {
    if (event.target.name === "low") {
      if (
        (event.target.value >= 0 || event.target.value == "") &&
        event.target.value != " "
      )
        setLowGoalRange(event.target.value.toString().trim());
    }
    if (event.target.name === "high") {
      if (
        (event.target.value >= 0 || event.target.value == "") &&
        event.target.value != " "
      )
        setHighGoalRange(event.target.value.toString().trim());
    }
  };

  return (
    <BodyWrapper>
      <div className="section">
        <div className="inputBoxName">Low</div>
        <div className="inputBoxContainer">
          <span>$</span>
          <input
            name="low"
            className="inputBox"
            value={lowGoalRange}
            onChange={handleTextBoxChange}
          />
        </div>

        <div className="inputBoxName" style={{ marginTop: 10 }}>
          High
        </div>
        <div className="inputBoxContainer">
          <span>$</span>
          <input
            name="high"
            className="inputBox"
            value={highGoalRange}
            onChange={handleTextBoxChange}
          />
        </div>
      </div>
    </BodyWrapper>
  );
};

export default GoalFilter;
